import React        from 'react';


class Colovr extends React.Component {


    render(){

        return (
            <section id="viewContainer" className={"content " +  this.props.classes}>

                <div id="mainContainer">
                    <div id="colovrContainer"></div>
                </div>   

                <div id="colovrColors">
                    <div className="colovr-colors-main"></div>
                    <div className="colovr-colors-dark"></div>
                    <div className="colovr-colors-light"></div>
                </div>

                <div className="ui-guide-message"><span>Ready to Gueff?</span></div>

            </section>
        )
    }
}


export default Colovr;